<script setup lang="ts">
/**
 * "ติดแท็ก" in the chat header, left of "ให้ AI ดูแล" (owner 18 ต.ค. 69 "เอาติดแท็กมาไว้ตรงนี้ดีกว่าเพราะใช้บ่อย" — moved out
 * of the "…" menu): customer chats with a contact (not groups) · the number = tags on the customer (names on hover) ·
 * opens the same TagPickerDialog. Narrow chat column: icon + number only, like "ย้ายแชท".
 */
import { computed, ref, watch } from 'vue'
import type { ConversationDetail } from '../../api/types'
import TagPickerDialog from '../collab/TagPickerDialog.vue'
import Icon from '../ui/Icon.vue'

const props = defineProps<{ detail: ConversationDetail }>()
const open = ref(false)
const taggable = computed(() => props.detail.kind !== 'group' && !!props.detail.contact.id)
const tags = computed(() => props.detail.tags ?? [])
const title = computed(() =>
  tags.value.length ? `แท็กลูกค้า: ${tags.value.map((t) => t.name).join(' · ')}` : 'ติดแท็กลูกค้า',
)
watch(
  () => props.detail.id,
  () => (open.value = false),
)
</script>

<template>
  <button
    v-if="taggable"
    type="button"
    class="btn tag-b"
    aria-haspopup="dialog"
    :aria-label="title"
    :title="title"
    @click="open = true"
  >
    <Icon name="tag" /><span class="tag-l">ติดแท็ก</span><span v-if="tags.length" class="tag-n">{{ tags.length }}</span>
  </button>
  <TagPickerDialog v-if="open" :detail="detail" @close="open = false" />
</template>

<style scoped>
.tag-n {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #e3f1ea;
  color: #0a5e47;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}
/* narrow chat column (ChatView.vue `.chat` container): a square icon button like "ย้ายแชท" (its aria-label / title say
   "ติดแท็ก"), the number as a small badge on its corner — the customer's name keeps its room */
@container (max-width: 600px) {
  .tag-l {
    display: none;
  }
  .tag-b {
    position: relative;
    width: 32px;
    padding: 0;
    justify-content: center;
  }
  .tag-n {
    position: absolute;
    top: -6px;
    right: -6px;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border: 1.5px solid #fff;
    border-radius: 9px;
    background: var(--ac);
    color: #fff;
    font-size: 12px;
    line-height: 15px;
  }
}
</style>
